import { PaletteMode } from '@mui/material';

import { palette } from './palette';
import tokensDark from './tokens-dark';
import tokensLight from './tokens-light';
import { createTokens } from './component-tokens';
import { typographyTokens } from './typography-tokens';
import { detailTokens } from './detail-tokens';

declare module '@mui/material/styles' {
  interface TypeText {
    other: typeof palette;
    tokens: typeof tokensDark | typeof tokensLight;
  }

  interface Palette {
    palette: typeof palette;
    tokens: typeof tokensDark | typeof tokensLight;
    componentTokens: ReturnType<typeof createTokens>;
    typographyTokens: typeof typographyTokens;
    detailTokens: typeof detailTokens;
  }

  interface PaletteOptions {
    palette?: typeof palette;
    tokens?: typeof tokensDark | typeof tokensLight;
    componentTokens?: ReturnType<typeof createTokens>;
    typographyTokens?: typeof typographyTokens;
    detailTokens?: typeof detailTokens;
  }
}

export const tokens = (mode: PaletteMode) =>
  ({
    light: tokensLight,
    dark: tokensDark,
  })[mode] ?? tokensDark;

// This function creates component tokens from semantic tokens following the hierarchy:
// Component Theme → Component Tokens → Semantic Tokens → Palette
const componentTokens = (mode: PaletteMode) => {
  const lightOrDarkTokens = tokens(mode);

  return createTokens(lightOrDarkTokens as typeof tokensDark);
};

export const themePalette = (mode: PaletteMode) => ({
  mode,
  palette, // Add the palette object so color tokens like 'green-500', 'blue-400' are accessible
  tokens: tokens(mode),
  componentTokens: componentTokens(mode),
  typographyTokens,
  detailTokens,
});
